import * as React from 'react';
import { config } from '../../../config';

interface IProps {
    headline: string;
}
const style = {
    header: {
        backgroundImage: `url(${config.images}/common/faq_contact_background.jpg)`,
    },
    icon: {
        backgroundImage: `url(${config.images}/common/faq.svg)`,
    },
};
export const FAQHeader = ({ headline }: IProps) => (
    <div className="faqPage--header" style={style.header}>
        <div className="faqPage--header-overlay" />
        <div className="faqPage--header-data">
            <span className="faqPage--header-icon" style={style.icon} />
            <div
                className="faqPage--header-content"
                dangerouslySetInnerHTML={{ __html: headline }}
            />
        </div>
    </div>
);
